import {
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  ADD_USER_FAIL,
  ADD_USER_SUCCESS,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_PHOTO_SUCCESS,
  UPDATE_USER_PHOTO_FAIL,
  RESET_USER_SUCCESS,
  GET_PAYRATES_SUCCESS,
  GET_PAYRATES_FAIL,
  DELETE_PAYRATE_SUCCESS,
  DELETE_PAYRATE_FAIL,
  ADD_PAYRATE_SUCCESS,
  ADD_PAYRATE_FAIL,
  GET_PAYRATE_DETAIL_SUCCESS,
  GET_PAYRATE_DETAIL_FAIL,
  UPDATE_PAYRATE_SUCCESS,
  UPDATE_PAYRATE_FAIL,
  GET_EMPLOYMENT_TYPES_SUCCESS,
  GET_EMPLOYMENT_TYPES_FAIL,
  GET_CLASSIFICATION_TYPES_SUCCESS,
  GET_CLASSIFICATION_TYPES_FAIL,
  GET_USER_AVAILABILITY_SUCCESS,
  GET_USER_AVAILABILITY_FAIL,
  ADD_USER_AVAILABILITY_SUCCESS,
  ADD_USER_AVAILABILITY_FAIL,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAIL,
  ADD_USER_PROFILE_SUCCESS,
  ADD_USER_PROFILE_FAIL,
  GET_HOUR_TYPES_SUCCESS,
  GET_HOUR_TYPES_FAIL,
  GET_GENDERS_SUCCESS,
  GET_GENDERS_FAIL,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  UPDATE_IMPERSONATE_USER_SUCCESS,
  UPDATE_IMPERSONATE_USER_FAIL,
  DELETE_IMPERSONATE_USER_SUCCESS,
  DELETE_IMPERSONATE_USER_FAIL,
  RESET_USER_PASSWORD_SUCCESS,
  RESET_USER_PASSWORD_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  users: [],
  payrates: [],
  payrate: {},
  employmentTypes: [],
  classificationTypes: [],
  user: {},
  useravailability: [],
  userprofile: {},
  error: {},
  loading: true,
  hourTypes: [],
  genders: [],
  userprofile: {},
  error: {},
  resetUserPassword: {},
  lmsRowID: "",
  loading: false,
}

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: true,
      }
    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_USER_SUCCESS: {
      return {
        ...state,
        users: state.users.filter(user => user.UserID !== action.payload),
      }
    }
    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users, action.payload],
      }
    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: true,
      }

    case GET_USER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.UserID.toString() === action.payload.UserID.toString()
            ? { user, ...action.payload }
            : user
        ),
      }
    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_USER_PHOTO_SUCCESS:
      return {
        ...state,
      }

    case UPDATE_USER_PHOTO_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      }

    // payrate

    case GET_PAYRATES_SUCCESS:
      return {
        ...state,
        payrates: action.payload,
        loading: true,
      }
    case GET_PAYRATES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_PAYRATE_SUCCESS: {
      return {
        ...state,
        payrates: state.payrates.filter(
          payrate => payrate.PayRateID !== action.payload
        ),
      }
    }
    case DELETE_PAYRATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_PAYRATE_SUCCESS:
      return {
        ...state,
        payrates: action.payload,
      }
    case ADD_PAYRATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PAYRATE_DETAIL_SUCCESS:
      return {
        ...state,
        payrate: action.payload,
        loading: true,
      }

    case GET_PAYRATE_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_EMPLOYMENT_TYPES_SUCCESS:
      return {
        ...state,
        employmentTypes: action.payload,
        loading: true,
      }
    case UPDATE_PAYRATE_SUCCESS:
      return {
        ...state,
        payrates: state.payrates.map(payrate =>
          payrate.PayRateID.toString() === action.payload.PayRateID.toString()
            ? { payrate, ...action.payload }
            : payrate
        ),
      }
    case UPDATE_PAYRATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_EMPLOYMENT_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CLASSIFICATION_TYPES_SUCCESS:
      return {
        ...state,
        classificationTypes: action.payload,
        loading: true,
      }
    case GET_CLASSIFICATION_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_AVAILABILITY_SUCCESS:
      return {
        ...state,
        useravailability: action.payload,
        loading: true,
      }
    case GET_USER_AVAILABILITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_USER_AVAILABILITY_SUCCESS:
      return {
        ...state,
        useravailability: action.payload,
      }
    case ADD_USER_AVAILABILITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userprofile: action.payload,
        loading: true,
      }
    case GET_USER_PROFILE_FAIL:
      return {
        ...state,
        userprofile: {},
        error: action.payload,
      }
    case ADD_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userprofile: action.payload,
      }
    case ADD_USER_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_HOUR_TYPES_SUCCESS:
      return {
        ...state,
        hourTypes: action.payload,
        loading: true,
      }
    case GET_HOUR_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GENDERS_SUCCESS:
      return {
        ...state,
        genders: action.payload,
        loading: true,
      }
    case GET_GENDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        userprofile: action.payload,
        loading: true,
      }
    case GET_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_IMPERSONATE_USER_SUCCESS:
      return {
        ...state,
        userprofile: action.payload,
        loading: true,
      }
    case UPDATE_IMPERSONATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_IMPERSONATE_USER_SUCCESS:
      return {
        ...state,
        loading: true,
      }
    case DELETE_IMPERSONATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        resetUserPassword: action.payload,
        loading: true,
      }
    case RESET_USER_PASSWORD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default User
